import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Chip, Tooltip } from '@mui/material';
import React from 'react';

/**
 * "View only", beside a page's title, for a role that may read the page but change nothing on it.
 *
 * The write controls on such a page are HIDDEN, not disabled (owner, 2026-11-03): a greyed-out
 * Sync button invites the question of how to enable it. Hiding them leaves the opposite question
 * -- is something missing? -- and this chip answers it. Pages take it through the `badge` slot of
 * PageHeader, CRMPageTemplate and EntityWorkspace, so it always sits in the same place.
 *
 * Presentation only. The BFF refuses the writes for the same roles whatever the page shows.
 */
const ViewOnlyChip: React.FC = () => (
  <Tooltip title="Your role can see this page but not change it.">
    <Chip
      className="cc-view-only-chip"
      data-testid="view-only-chip"
      icon={<VisibilityOutlinedIcon />}
      label="View only"
    />
  </Tooltip>
);

export default ViewOnlyChip;
